import {
  Button,
  Form,
  FormControl,
  FormGroup,
  FormLabel,
} from "@themesberg/react-bootstrap";
import React, { useState } from "react";
import { axiosInstance } from "../../../../config/axios";
import { APIURL } from "../../../../configApi";
import { NotificationManager } from "react-notifications";

const EditGroupe = (props) => {
  const { refreshGroupeList, groupe, setEditGroupe } = props;
  const [groupe_name, setGroupe_Name] = useState(groupe.name);

  const updateGroupre = (e) => {
    e.preventDefault();

    axiosInstance
      .put(`${APIURL}/laboratory/groups/${groupe.id}`, { name: groupe_name })
      .then((res) => {
        // console.log(res.data)
        NotificationManager.success(
          "Nom du groupe modifié avec succès",
          "Notification"
        );
        refreshGroupeList();
        //setGroupe_Name('')
      })
      .catch((err) => {
        // console.log(err)
        NotificationManager.error(
          "Erreur lors de la modification  d'un Groupe",
          "Notification"
        );
      });
    setEditGroupe(false);
  };

  return (
    <Form className={"d-flex align-items-end mb-3"} onSubmit={updateGroupre}>
      <FormGroup className={"w-75 me-4"}>
        <FormLabel>Nom du groupe</FormLabel>
        <FormControl
          type={"text"}
          placeholder={"Nom du groupe ..."}
          value={groupe_name}
          onChange={(e) => setGroupe_Name(e.target.value)}
        ></FormControl>
      </FormGroup>
      <FormGroup>
        <Button variant={"btn btn-primary"} type={"submit"}>
          {" "}
          Modifier{" "}
        </Button>
      </FormGroup>
    </Form>
  );
};

export default EditGroupe;
